export default function or(a, b) {
  return Boolean(a || b);
}